/**
 * Container label identity (ADR-0027): the human-readable short UUID and the
 * four-icon pictogram set derived from a container's UUID. The frozen 64-icon
 * alphabet lives in docs/icons.md; ICONS_64 mirrors it (see identify.test.ts).
 */
/** The app-wide short form of a UUID: its first 7 hex characters. */
export const SHORT_UUID_LENGTH = 7;
/**
 * The frozen 64-icon free-solid FontAwesome alphabet (ADR-0027). Additive-only:
 * replacing or renumbering an entry changes every label ever printed.
 */
export const ICONS_64 = [
    // 0-7: Animals and Fairy tales
    "fa-cat", "fa-dog", "fa-spider", "fa-horse", "fa-fish", "fa-frog", "fa-dove", "fa-dragon",
    // 8-15: Vehicles
    "fa-bicycle", "fa-car", "fa-tractor", "fa-anchor", "fa-cable-car", "fa-helicopter", "fa-plane", "fa-rocket",
    // 16-23: Nature & weather
    "fa-sun", "fa-moon", "fa-fire", "fa-snowflake", "fa-bolt-lightning", "fa-cloud-rain", "fa-tree", "fa-leaf",
    // 24-31: Food
    "fa-pizza-slice", "fa-burger", "fa-apple-whole", "fa-lemon", "fa-carrot", "fa-cookie-bite", "fa-ice-cream", "fa-cake-candles",
    // 32-39: Body and cloths
    "fa-hand", "fa-tooth", "fa-eye", "fa-glasses", "fa-headphones", "fa-shower", "fa-socks", "fa-shirt",
    // 40-47: Daily tools
    "fa-pen", "fa-utensils", "fa-key", "fa-scissors", "fa-hammer", "fa-magnifying-glass", "fa-paperclip", "fa-umbrella",
    // 48-55: Sport and Music
    "fa-futbol", "fa-basketball", "fa-trophy", "fa-crown", "fa-guitar", "fa-drum", "fa-microphone", "fa-bell",
    // 56-63: Landmark and Symbols
    "fa-earth-americas", "fa-map", "fa-flag", "fa-house", "fa-heart", "fa-star", "fa-clock", "fa-phone",
];
/** The short UUID of a container: its first 7 hex characters (ADR-0027). */
export function shortUuid(uuid) {
    return uuid.slice(0, SHORT_UUID_LENGTH);
}
/**
 * The four short-UUID pictograms for a container (ADR-0027): the first 24 bits
 * of the UUID (its first 6 hex characters) are read most-significant first,
 * 6 bits per icon, selecting from ICONS_64.
 */
export function shortUuidIcons(uuid) {
    const n = Number.parseInt(uuid.slice(0, 6), 16);
    return Array.from({ length: 4 }, (_, k) => {
        // The 0x3f mask keeps the index in 0..63, so the lookup always hits.
        const i = (n >> (18 - k * 6)) & 0x3f;
        return ICONS_64[i];
    });
}
//# sourceMappingURL=identify.js.map